export default {"src":"/_next/static/media/vector.afd225e2.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};